require("@babel/polyfill");
require("react-hot-loader");
require("react");
require("react-dom");
require("styled-components");
require("isomorphic-fetch");
// TODO(KentoMoriwaki): Remove these from global vendor.
require("react-dnd");
require("react-motion");



// WEBPACK FOOTER //
// ./frontend/src/vendor.js